//namespace Pacem {
export class TemplateElement extends HTMLElement {
}
//}
